import { ImageProps } from "@outschool/backpack";
import { ErrorMessage } from "@outschool/ui-components-shared";
import { Loading } from "@outschool/ui-legacy-component-library";
import React from "react";

import useContentfulHomePage2Query from "../hooks/useContentfulHomePage2Query";
import CardLinkGrid from "./CardLinkGrid";
import CircleLinkGrid from "./CircleLinkGrid";

type VisualLinkGridProps = {
  error?: ReturnType<typeof useContentfulHomePage2Query>["error"];
  loading?: ReturnType<typeof useContentfulHomePage2Query>["loading"];
  item?: ReturnType<typeof useContentfulHomePage2Query>["items"][number];
  renderImage?: (props: ImageProps) => React.ReactElement;
};

export default function VisualLinkGrid({
  error,
  loading,
  item,
  renderImage,
}: VisualLinkGridProps) {
  if (!!loading) {
    return <Loading />;
  }

  if (!!error) {
    return <ErrorMessage value={error} />;
  }

  const { visualLinksCollection, title, style } = item;

  if (style === "card-link-grid") {
    return (
      <CardLinkGrid
        title={title}
        items={visualLinksCollection.items}
        renderImage={renderImage}
      />
    );
  }

  if (style === "circle-link-grid") {
    return (
      <CircleLinkGrid
        title={title}
        items={visualLinksCollection.items}
        renderImage={renderImage}
      />
    );
  }

  // TODO: report invalid link grid style

  return <></>;
}
